import { Component, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DOUBLET_PROVIDER_SERVICE, IDoubletProviderService } from 'src/app/lib/shared/interfaces';
import { Contact } from '../../../classes';
import { DEPARTMENTS_PROVIDER_SERVICE, IDepartmentsProviderService } from '../../../interfaces';
import { ContactService } from '../../../services/contact.service';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnDestroy, OnInit {

  @Input() editMode: boolean = true;
  @Input() appearance: 'standard' | 'fill' | 'outline' = 'fill';

  salutations = [ 'Herr', 'Frau' ];

  formGroup: FormGroup;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Optional() @Inject(DOUBLET_PROVIDER_SERVICE) public doubletService: IDoubletProviderService,
    @Optional() @Inject(DEPARTMENTS_PROVIDER_SERVICE) public departmentsProviderService: IDepartmentsProviderService,
    private _controlContainer: ControlContainer,
    private _contactService: ContactService
  ) { }

  clearDepartment(){
    this.formGroup.controls['contactpersondepartment'].setValue(null);
    this.formGroup.controls['contactpersondepartment'].markAsDirty();    
  }

  clearFirstname = () => {
    this.formGroup.controls['contactpersfname'].setValue(null);
    this.formGroup.controls['contactpersfname'].markAsDirty();
  }

  clearNumber = () => {
    this.formGroup.controls['contactperspublicid'].setValue(null);
    this.formGroup.controls['contactperspublicid'].markAsDirty();
  }

  clearSalutation = () => {
    this.formGroup.controls['contactperssalutation'].setValue(null);
    this.formGroup.controls['contactperssalutation'].markAsDirty();
  }

  clearSurname = () => {
    this.formGroup.controls['contactperslname'].setValue(null);
    this.formGroup.controls['contactperslname'].markAsDirty();
  }
  
  generateNumber = () => this._contactService.generateNumber().subscribe((number: number) => {
    this.publicIdControl.setValue(number);
    this.publicIdControl.markAsDirty();
  });
  
  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = []; Contact
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;

    if (this.doubletService) this._subscriptions.push(this.surnameControl.valueChanges.pipe(debounceTime(1000)).subscribe((value: string) => {
      this.doubletService.setSearchString(value);
    }));
  }

  get publicIdControl(): AbstractControl {
    return this.formGroup.controls['contactperspublicid'];
  }
  get salutationControl(): AbstractControl {
    return this.formGroup.controls['contactperssalutation'];
  }
  get firstNameControl(): AbstractControl {
    return this.formGroup.controls['contactpersfname'];
  }
  get surnameControl(): AbstractControl {
    return this.formGroup.controls['contactperslname'];
  }
  get departmentControl(): AbstractControl {
    return this.formGroup.controls['contactpersondepartment'];
  }

}
